import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import { DOCUMENT_STATES } from 'utils/Constants';

import Icon from 'components/Misc/Icon';
import { Title } from 'components/Misc/Typography';

const className = classnames(
	'py-3 px-4 flex flex-col space-y-2 ring-amber-500 rounded-lg cursor-pointer transition-all',
	'bg-white dark:bg-neutral-800',
	'hover:ring focus:ring',
);

const Document = ({ document }) => {
	// Find status info
	const status = useMemo(() => DOCUMENT_STATES.find(status => status.value === document.status), [document.status]);

	const statusClassName = classnames(
		'flex items-center space-x-1 text-sm',
		document?.status === 'visible' && 'text-emerald-500',
		document?.status === 'hidden' && 'text-amber-500'
	);

	return (
		<Link
			to={`/documents/${document.id}`}
			className={className}
		>
			<Title title={document.title} />

			<div className="flex flex-wrap">
				<div className={statusClassName}>
					<Icon icon="visibility" className="text-base" />
					<div className="text-xs">{status?.text}</div>
				</div>
			</div>
		</Link>
	);
};

export default Document;
